import React from 'react';
import { useSelector } from 'react-redux';
import { EmptyState } from '../../../components/ui';
import { UserRoles } from '../../../data/enums';

// One admin gate for every Devices view (P-8). The fetching component sits
// INSIDE it, so no fetch hook runs for a non-admin.
const AdminOnly = ({ children }) => {
  const roles = useSelector((state) => state.authReducer.roles);
  if (!roles?.includes(UserRoles.ADMIN)) {
    return (
      <div className="min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
        <div className="mx-auto max-w-7xl space-y-6">
          <EmptyState
            title="Admins only"
            description="The Devices area is for Thisway administrators."
          />
        </div>
      </div>
    );
  }
  return <>{children}</>;
};

export default AdminOnly;
